/** Shared by both cards. Capped against the viewport: a fixed height on a short screen
 *  is taller than the visible area, putting the scroll region itself out of reach. */
export const DASHBOARD_CARD_HEIGHT = 'h-[min(28rem,calc(100dvh-12rem))]';

/** Fixed too, or the card with a button in its header starts its list 10px lower. */
export const DASHBOARD_CARD_HEADER = 'h-14 shrink-0';
